import React, { useState, useEffect } from 'react';
import { Button, Space, Breadcrumb } from 'antd';
import { CardLayout, SortableTable, RefCodeEditModal } from 'components/molecules';
import { useRefCode } from 'hooks';
import { ColumnsType } from 'antd/lib/table/interface';
import { TotalNumMenu } from 'components/atoms';
import { usePopupManager } from 'react-popup-manager';
import * as XLSX from 'xlsx';

export interface LectureGubunProps {}

const LectureGubun = ({}: LectureGubunProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */
  const [tableDatas, setTableDatas] = useState<any[]>();
  const [title] = useState<string>('강의구분');
  const [fieldName] = useState<string>('lecture_type1');
  const { open } = usePopupManager();

  const columns: ColumnsType<RefCodeListDto> = [
    {
      key: 'sort',
      width: '70px',
      align: 'center',
    },  
    {
      title: '강의구분명',
      dataIndex: 'value',
      key: 'value',
      width: 'auto',
      align: 'left',
      render: (value, record) => {
        return (
          <span style={{color:record.status_type === 'AV'?'#000':'#f00'}}>{value}</span>
        )
      }      
    },
    {
      title: '생성일',
      dataIndex: 'created',
      key: 'created',
      width: '120px',
      align: 'center',
    },
    {
      title: '사용여부',
      dataIndex: 'status_type',
      key: 'status_type',
      width: '80px',
      align: 'center',
      render: (status_type, record) => {
        return (
          <Button
            type='default'
            onClick={(e) => {
              e.stopPropagation();

              refCodeUpdate({ref_code_srl: record.ref_code_srl, status_type: status_type === 'AV'?'HD':'AV'})
            }}
          >{status_type === 'AV' ? 'YES' : 'NO'}</Button>
        )
      }
    }, 
  ];

  /* ======================================================
   * hooks
   * ====================================================== */
  const { refCodeList, refCodeInsert, refCodeUpdate, refCodeSort } = useRefCode({field:fieldName});  

  /* ======================================================
   * events
   * ====================================================== */    
  const onSort = (active: string | number, over: string | number)  => {
    refCodeSort({active: active as number, over: over as number})
  }

  const onClickRegister = () => {
    open(RefCodeEditModal, {
      title: title,
      ref_code_srl: 0,
      useCreate: true,
      onClose: (isOk, value, create) => {
        if (isOk) {
          refCodeInsert({
            field: fieldName,
            name_alias: 'TN',
            value: value,
            created: create,
          })    
        }
      },
    }); 
  }

  const onRowClick = (record: any) => {
    open(RefCodeEditModal, {
      title: title,      
      ref_code_srl: record.ref_code_srl,
      value: record.value,
      created: record.created,
      useCreate: true,
      onClose: (isOk, value, created) => {
        if (isOk) {
          refCodeUpdate({ref_code_srl: record.ref_code_srl, value: value, created: created})     
        }
      },
    });   
  }


  const onDownloadExcel = () => {
    if (!!refCodeList) {
      const book = XLSX.utils.book_new();
    
      const nurses = XLSX.utils.json_to_sheet(
        refCodeList.map((item, index) => {
          return {
            '강의구분명' : item.value,
            '생성일' : item.created,
            '사용여부': item.status_type === 'AV' ? 'YES' : 'NO',
          }
        }), 
        { 
          header : [
            '강의구분명',
            '생성일',
            '사용여부',
          ], 
          skipHeader : false 
        } 
      );
  
      nurses["!cols"] = [
        { wpx : 150 } 
      , { wpx : 100 } 
      , { wpx : 60 } 
      ]
  
      XLSX.utils.book_append_sheet( book, nurses, "NURSES" );
  
      XLSX.writeFile( book, "강의구분.xlsx" ); 
    }
  }  
  /* ======================================================
   * effects
   * ====================================================== */
  useEffect(() => {
    setTableDatas(refCodeList?.map((item) => ({
      ...item,
      key: item.ref_code_srl,
    })));
  }, [refCodeList]);

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <CardLayout title={(
      <Breadcrumb>
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>기초정보관리</Breadcrumb.Item>
        <Breadcrumb.Item>강의구분</Breadcrumb.Item>
    </Breadcrumb>      
    )}>
        <Space direction="vertical" style={{ width: '100%' }}>
          <TotalNumMenu text={' '} useRegister useExcelDownload onDownloadExcel={onDownloadExcel} onUseRegister={onClickRegister} />
          <SortableTable
            dataList={tableDatas as any[]}
            columns={columns}
            onSort={onSort}
            onClick={onRowClick}
          />
        </Space>                
    </CardLayout>
  )
};

export default LectureGubun;    